import FingoMuiPickersDay, { defaultPickersDayStyles } from '../../fingo/components/MuiPickersDay';
import DEFAULT_PICKERSDAY_CLASS_NAME from '../../constants/pickers-day';

const MuiPickersDay = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      ...FingoMuiPickersDay.styleOverrides.root({ theme, ownerState }),
      [`&.${DEFAULT_PICKERSDAY_CLASS_NAME}`]: defaultPickersDayStyles({ theme, ownerState, mainColor: theme.palette.secondary.A400 }),
    }),
  },
};

export default MuiPickersDay;
